import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SITE_URL } from "../../content/site";
import { routeSeo } from "../../content/seo";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setJsonLd = (data) => {
  let el = document.getElementById("route-jsonld");
  if (!data) return el?.remove();
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = "route-jsonld";
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
};

export const Seo = ({ metaKey }) => {
  const { pathname } = useLocation();
  useEffect(() => {
    const path = pathname.length > 1 ? pathname.replace(/\/$/, "") : pathname;
    const m = routeSeo(path, metaKey);
    document.title = m.title;
    setMeta("name", "description", m.description);
    setMeta("property", "og:title", m.title);
    setMeta("property", "og:description", m.description);
    setMeta("property", "og:url", m.url);
    setMeta("property", "og:image", `${SITE_URL}/images/og.jpg`);
    setMeta("name", "twitter:image", `${SITE_URL}/images/og.jpg`);
    setMeta("name", "twitter:title", m.title);
    setMeta("name", "twitter:description", m.description);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = m.url;
    setJsonLd(metaKey === "404" ? null : m.jsonLd);
  }, [pathname, metaKey]);
  return null;
};
